// Global event bus for coordinating between TranslatorBot and SignLanguageWidget
// This allows the avatar to sign what the bot is reading

class SignLanguageEventBus {
  constructor() {
    this.listeners = new Set();
  }

  // Subscribe to sign language events
  subscribe(callback) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  // Emit text to be signed
  emitSignText(text) {
    this.listeners.forEach(callback => {
      try {
        callback({ type: 'SIGN_TEXT', text });
      } catch (e) {
        console.error('SignLanguageEventBus listener error:', e);
      }
    });
  }

  // Emit stop signing
  emitStopSigning() {
    this.listeners.forEach(callback => {
      try {
        callback({ type: 'STOP_SIGNING' });
      } catch (e) {
        console.error('SignLanguageEventBus listener error:', e);
      }
    });
  }
}

// Singleton instance
export const signLanguageEventBus = new SignLanguageEventBus();

// Hook for components to use
export const useSignLanguageSync = () => {
  return {
    triggerSign: (text) => signLanguageEventBus.emitSignText(text),
    stopSign: () => signLanguageEventBus.emitStopSigning(),
    subscribe: (callback) => signLanguageEventBus.subscribe(callback)
  };
};
